
import API_ROOT from './api-root'

export const getSQLTemplate = (client, template_name, attribute_associations, record) => {
    const token = localStorage.getItem('token')
    return fetch(
        `${API_ROOT}/rpc/generate_boilerplate`, { 
            method: 'POST',
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
            "template_name": template_name,
            "template_parameters": {
                "CLIENT_NAME": client,
                "TABLE_PREFIX": record?.name,
                "CHAIN_MAPPING": attribute_associations?.includes("chain"),
                "WAREHOUSE_MAPPING": attribute_associations?.includes("warehouse"),
            }
            })
         }
    )
}
export const updatePassword = (email, old_password, new_password) => {
    const token = localStorage.getItem('token')
    return fetch(
        `${API_ROOT}/rpc/update_password`, { 
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                email: email,
                password: old_password,
                new_password: new_password
            })
         }
    )
}
export const insertAPIKey = (nickname) => {
    const token = localStorage.getItem('token')
    return fetch(
        `${API_ROOT}/rpc/insert_api_key`, { 
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                p_nickname: nickname,
              })
         }
    ).then(response => response.json())
}